// BFCM Promo Bar - Shows after scrolling a certain percentage

document.addEventListener("DOMContentLoaded", () => {
  const promoBar = document.getElementById("bfcm-promo-bar");
  
  if (!promoBar) return;
  
  const scrollPercent = parseInt(promoBar.dataset.scrollPercent) || 20;
  const closeButton = promoBar.querySelector(".bfcm-promo-bar__close");
  const storageKey = "bfcm-promo-bar-dismissed";
  
  // Check if user has dismissed the bar
  if (localStorage.getItem(storageKey) === "true") {
    promoBar.style.display = "none";
    return;
  }
  
  // Calculate scroll threshold
  const getScrollThreshold = () => {
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    return (documentHeight * scrollPercent) / 100;
  };
  
  let scrollThreshold = getScrollThreshold();
  
  // Recalculate on resize
  window.addEventListener("resize", () => {
    scrollThreshold = getScrollThreshold();
  });
  
  // Handle scroll
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop >= scrollThreshold) {
      promoBar.classList.add("bfcm-promo-bar--visible");
    } else {
      promoBar.classList.remove("bfcm-promo-bar--visible");
    }
  };
  
  window.addEventListener("scroll", handleScroll, { passive: true });
  
  // Handle close button
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      promoBar.classList.remove("bfcm-promo-bar--visible");
      localStorage.setItem(storageKey, "true");
      
      // Optionally remove from DOM after animation
      setTimeout(() => {
        promoBar.style.display = "none";
      }, 300);
    });
  }
  
  // Initial check in case page is already scrolled
  handleScroll();
});

